import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonAvatar, chameleonAvatarV2 } from '../Avatar/Avatar.definition';
import { chameleonAvatarGroup } from './AvatarGroup.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonAvatarGroup({ prefix }), chameleonAvatar({ prefix }), chameleonAvatarV2({ prefix }));
}
